import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { playSuccess, playError } from '../utils/SoundManager';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function ContactPage() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) return;

    setSending(true);
    try {
      await axios.post(`${BACKEND_URL}/api/contact`, form);
      setSent(true);
      playSuccess();
    } catch (err) {
      playError();
      alert('حدث خطأ في إرسال الرسالة. حاول مرة أخرى.');
    } finally {
      setSending(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--light-bg)' }}>
      <div className="header">
        <div className="header-content">
          <h1 className="logo" onClick={() => navigate('/')} style={{cursor: 'pointer'}}>وِداد</h1>
        </div>
      </div>

      <div className="container" style={{ paddingTop: '30px', paddingBottom: '60px', maxWidth: '700px' }}>
        
        {sent ? (
          <div className="card fade-in" style={{ textAlign: 'center', padding: '50px 32px', borderRadius: '20px' }}>
            <div className="heartbeat" style={{ fontSize: '60px', marginBottom: '16px' }}>✅</div>
            <h2 style={{ color: 'var(--text-dark)', marginBottom: '12px' }}>تم إرسال رسالتك بنجاح!</h2>
            <p style={{ color: 'var(--text-light)', fontSize: '16px', lineHeight: '1.8' }}>
              سنرد عليك في أقرب وقت ممكن. شكراً لتواصلك معنا.
            </p>
            <button 
              className="btn btn-primary"
              onClick={() => navigate('/dashboard')}
              style={{ marginTop: '24px', padding: '14px 40px' }}
            >
              العودة للرئيسية
            </button>
          </div>
        ) : (
          <div className="card fade-in" style={{ padding: '32px', borderRadius: '20px' }}>
            <div style={{ textAlign: 'center', marginBottom: '28px' }}>
              <div style={{ fontSize: '48px', marginBottom: '12px' }}>📬</div>
              <h1 style={{ fontSize: '28px', color: 'var(--text-dark)', marginBottom: '8px' }}>اتصل بنا</h1>
              <p style={{ color: 'var(--text-light)', fontSize: '15px' }}>نسعد بتواصلكم ونرد على استفساراتكم</p>
            </div>

            {/* معلومات التواصل */}
            <div style={{ 
              display: 'grid', 
              gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
              gap: '12px',
              marginBottom: '28px'
            }}>
              <div style={{ 
                background: 'rgba(0, 137, 123, 0.08)',
                border: '1px solid rgba(0, 137, 123, 0.2)',
                borderRadius: '12px', padding: '16px', textAlign: 'center'
              }}>
                <div style={{ fontSize: '28px', marginBottom: '8px' }}>📧</div>
                <p style={{ color: 'var(--text-light)', fontSize: '12px', marginBottom: '4px' }}>البريد الإلكتروني</p>
                <p style={{ color: 'var(--text-dark)', fontWeight: '600', fontSize: '14px', margin: 0 }}>help@wedad.online</p>
              </div>
              <div style={{ 
                background: 'rgba(192, 110, 237, 0.08)',
                border: '1px solid rgba(192, 110, 237, 0.2)',
                borderRadius: '12px', padding: '16px', textAlign: 'center'
              }}>
                <div style={{ fontSize: '28px', marginBottom: '8px' }}>🌐</div>
                <p style={{ color: 'var(--text-light)', fontSize: '12px', marginBottom: '4px' }}>الموقع</p>
                <p style={{ color: 'var(--text-dark)', fontWeight: '600', fontSize: '14px', margin: 0 }}>wedad.online</p>
              </div>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label className="form-label">الاسم</label>
                <input 
                  className="input"
                  data-testid="contact-name"
                  type="text"
                  required
                  value={form.name}
                  onChange={e => setForm({...form, name: e.target.value})}
                  placeholder="اسمك الكريم"
                />
              </div>

              <div className="form-group">
                <label className="form-label">البريد الإلكتروني</label>
                <input 
                  className="input"
                  data-testid="contact-email"
                  type="email"
                  required
                  value={form.email}
                  onChange={e => setForm({...form, email: e.target.value})}
                  placeholder="example@email.com"
                  dir="ltr"
                />
              </div>

              <div className="form-group">
                <label className="form-label">الموضوع</label>
                <select 
                  className="select"
                  data-testid="contact-subject"
                  value={form.subject}
                  onChange={e => setForm({...form, subject: e.target.value})}
                >
                  <option value="">اختر الموضوع</option>
                  <option value="استفسار عام">استفسار عام</option>
                  <option value="مشكلة تقنية">مشكلة تقنية</option>
                  <option value="طلب استرداد">طلب استرداد</option>
                  <option value="بلاغ عن عضو">بلاغ عن عضو</option>
                  <option value="اقتراح أو ملاحظة">اقتراح أو ملاحظة</option>
                  <option value="شراكة أو تعاون">شراكة أو تعاون</option>
                </select>
              </div>

              <div className="form-group">
                <label className="form-label">الرسالة</label>
                <textarea 
                  className="input"
                  data-testid="contact-message"
                  required
                  rows={5}
                  value={form.message}
                  onChange={e => setForm({...form, message: e.target.value})}
                  placeholder="اكتب رسالتك هنا..."
                  style={{ resize: 'vertical', minHeight: '120px' }}
                />
              </div>

              <button 
                data-testid="contact-submit"
                type="submit"
                className="btn btn-primary btn-glow"
                disabled={sending}
                style={{ width: '100%', padding: '16px', fontSize: '16px' }}
              >
                {sending ? 'جاري الإرسال...' : '📤 إرسال الرسالة'}
              </button>
            </form>
          </div>
        )}
      </div>
    </div>
  );
}

export default ContactPage;
